"use client";

import { createSystem, defaultConfig, defineRecipe } from "@chakra-ui/react";
import backgroundImage from "../images/background.jpg";

export const system = createSystem(defaultConfig, {
  globalCss: {
    body: {
      colorPalette: "brand",
      backgroundColor: "background",
      color: "ink",
      bgImage: `url(${backgroundImage})`,
      bgPos: "center",
      bgSize: "100px 100px",
      bgRepeat: "repeat",
    },
  },
  theme: {
    tokens: {
      fonts: {
        body: { value: "var(--font-inter)" },
      },
      colors: {
        accent: { value: "#f44b0d" },
        ink: { value: "#141f3f" },
        background: { value: "#FBF7EC" },
        brand: {
          50: { value: "#fce8e6" },
          100: { value: "#ffcbb9" },
          200: { value: "#ffa98c" },
          300: { value: "#ff875e" },
          400: { value: "#ff875e" },
          500: { value: "#ff5112" },
          600: { value: "#f44b0d" },
          700: { value: "#e64407" },
          800: { value: "#d83c02" },
          900: { value: "#c02e00" },
        },
        brandSecondary: {
          50: { value: "#e5e8ed" },
          100: { value: "#bec5d4" },
          200: { value: "#94a0b7" },
          300: { value: "#6d7b9a" },
          400: { value: "#4f6087" },
          500: { value: "#314776" },
          600: { value: "#2b406e" },
          700: { value: "#233763" },
          800: { value: "#1d2e57" },
          900: { value: "#141f3f" },
        },
      },
    },
    semanticTokens: {
      radii: {
        l1: { value: "0.5rem" },
        l2: { value: "0.75rem" },
        l3: { value: "1rem" },
        l4: { value: "1.5rem" },
      },
      shadows: {
        preview: {
          value: {
            _light: "0 0 60px 0 rgba(0, 0, 0, 0.1)",
            _dark: "0 0 60px 0 rgba(0, 0, 0, 0.1)",
          },
        },
        menu: {
          value: {
            _light: "0 0 60px 0 rgba(0, 0, 0, 0.075)",
            _dark: "0 0 60px 0 rgba(0, 0, 0, 0.075)",
          },
        },
      },
      colors: {
        brand: {
          contrast: {
            value: {
              _light: "white",
              _dark: "white",
            },
          },
          fg: {
            value: {
              _light: "{colors.brand.500}",
              _dark: "{colors.brand.300}",
            },
          },
          subtle: {
            value: {
              _light: "{colors.brand.100}",
              _dark: "{colors.brand.900}",
            },
          },
          muted: {
            value: {
              _light: "{colors.brand.100}",
              _dark: "{colors.brand.800}",
            },
          },
          emphasized: {
            value: {
              _light: "{colors.brand.300}",
              _dark: "{colors.brand.700}",
            },
          },
          solid: {
            value: {
              _light: "{colors.brand.500}",
              _dark: "{colors.brand.500}",
            },
          },
          focusRing: {
            value: {
              _light: "transparent",
              _dark: "transparent",
            },
          },
        },
      },
    },
    recipes: {
      container: {
        base: {
          maxWidth: {
            sm: "100%",
            md: "768px",
            lg: "980px",
            xl: "980px",
          },
          paddingX: { base: 3, lg: 0 },
        },
      },
      text: defineRecipe({
        variants: {
          paragraph: {
            true: {
              fontSize: "lg",
              fontWeight: "500",
            },
          },
          quote: {
            true: {
              fontSize: "xl",
              fontWeight: "700",
            },
          },
        },
      }),
      heading: defineRecipe({
        variants: {
          as: {
            h1: {
              fontSize: "4xl",
              lineHeight: "1.3",
              fontWeight: "700",
            },
            h2: {
              fontSize: "3xl",
              lineHeight: "1.3",
              fontWeight: "700",
              paddingTop: 6,
            },
          },
        },
      }),
    },
  },
});
